'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getWebrtcDefer = exports.getWebGLFingerPrint = exports.getIPs = exports.getAudioFP = exports.getCanvasFingerPrint = exports.getEnv = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uaParser = require('ua-parser-js');
var uAgent = uaParser(navigator.userAgent);
var browser = require('./browser');
var CryptoJS = require('crypto-js'); //引用AES源码js
var STO = void 0;

var CACHE = {
    // isPrivateMode: false
    tap_count: 0,
    mouse_click: 0,
    scroll_count: 0,
    key_count: 0,
    gyro_x: 0,
    gyro_y: 0,
    gyro_z: 0,
    acce_x: 0,
    acce_y: 0,
    acce_z: 0,
    touch_count: 0,
    mouse_move: 0,
    fp_audio: '',
    fp_webrtc: '',
    connection_type: '',
    page_link: ''
};

// 防止事件被重复绑定
window._HAS_BIND_EVENT_ENV = false;

/**
 * env module.
 * @author AlanZhang 封装对浏览器环境变量的获取
 * @module env
 */
exports.getEnv = getEnv;
exports.getCanvasFingerPrint = getCanvasFingerPrint;
exports.getAudioFP = getAudioFP;
exports.getIPs = getIPs;
exports.getWebGLFingerPrint = getWebGLFingerPrint;
exports.getWebrtcDefer = getWebrtcDefer;

/**
 * 工具方法
 * @private
 * @module
 */

var util = {
    /**
     * hex2bin in Javascript
     * @param {String} bin [bin]
     * @returns {String} [hex]
     */
    bin2hex: function bin2hex(bin) {
        var i = 0,
            l = bin.length,
            chr,
            hex = '';

        for (i; i < l; ++i) {
            chr = bin.charCodeAt(i).toString(16);
            hex += chr.length < 2 ? '0' + chr : chr;
        }
        return hex;
    },

    initEvent: function initEvent() {

        if (window._HAS_BIND_EVENT_ENV) {
            return;
        }
        window._HAS_BIND_EVENT_ENV = true;

        if ('ontouchstart' in window) {
            // 监听tap事件
            window.addEventListener('touchstart', function () {
                CACHE.tap_count++;
            });
            // 监听滑动事件
            window.addEventListener('touchmove', function () {
                CACHE.touch_count++;
            });
        }

        window.addEventListener('click', function () {
            getAudioFP(function (audioFP) {
                if (audioFP) {
                    CACHE.fp_audio = CACHE.fp_audio || CryptoJS.SHA1(audioFP).toString();
                }
            });
        });

        // 鼠标点击事件
        window.addEventListener('mousedown', function () {
            CACHE.mouse_click++;
        });

        // 鼠标滑动
        window.addEventListener('mousemove', function () {
            CACHE.mouse_move++;
        });

        // 键盘点击
        window.addEventListener('keydown', function () {
            CACHE.key_count++;
        });

        // 鼠标滚动事件
        window.addEventListener('scroll', function () {
            CACHE.scroll_count++;
        });

        // 陀螺仪事件
        window.DeviceOrientationEvent && window.addEventListener('deviceorientation', this.throttle(function (e) {
            CACHE.gyro_x = e.beta;
            CACHE.gyro_y = e.gamma;
            CACHE.gyro_z = e.alpha;
        }, 300), true);

        // 加速度
        window.DeviceMotionEvent && window.addEventListener('devicemotion', this.throttle(function (e) {
            if (e.acceleration) {
                CACHE.acce_x = e.accelerationIncludingGravity.x;
                CACHE.acce_y = e.accelerationIncludingGravity.y;
                CACHE.acce_z = e.accelerationIncludingGravity.z;
            }
        }, 300), true);
    },


    /**
    * 返回一个“节流”函数
    * @priavte
    * @param {Function} fn    实际要执行的函数
    * @param {Number} threshhold   执行间隔，单位是毫秒（ms）
    * @return {Function}     返回一个“节流”函数
    */
    throttle: function throttle(fn, threshhold) {

        // 记录上次执行的时间
        var last;
        // 定时器
        var timer;
        // 默认间隔为 250ms
        threshhold || (threshhold = 250);

        // 返回的函数，每过 threshhold 毫秒就执行一次 fn 函数
        return function () {
            // 保存函数调用时的上下文和参数，传递给 fn
            // eslint-disable-next-line no-invalid-this
            var context = this;
            var args = arguments;
            var now = +new Date();

            // 如果距离上次执行 fn 函数的时间小于 threshhold，那么就放弃
            // 执行 fn，并重新计时
            if (last && now < last + threshhold) {
                clearTimeout(timer);

                // 保证在当前时间区间结束后，再执行一次 fn
                timer = setTimeout(function () {
                    last = now;
                    fn.apply(context, args);
                }, threshhold);

                // 在时间区间的最开始和到达指定间隔的时候执行一次 fn
            } else {
                last = now;
                fn.apply(context, args);
            }
        };
    }

};

util.initEvent();

/**
 * 获取浏览器插件
 * @static
 * @private
 * @returns {Array} [{name:xxx,filename:xxx,description:xxx}]
 */
function getPlugins() {

    if (CACHE.hasOwnProperty('plugins')) {
        return CACHE.plugins;
    }

    var plugins = Array.prototype.slice.call(navigator.plugins, 0);
    if (!plugins || !Array.isArray(plugins)) {
        return [];
    }
    var arr = plugins.map(function (item) {
        return {
            name: item.name
        };
    });
    CACHE.plugins = arr;
    return arr;
}

/**
 * 获取canvas 的指纹信息,8位
 * @static
 * @public
 * @since 2.10.0
 * @return {String} [获取canvas 的指纹信息]
 */
function getCanvasFingerPrint() {
    var crc = '';

    if (!document.createElement('canvas').getContext) {
        return crc;
    }

    // 防止一部分浏览器在处理canvas 和 时报错
    try {
        // https://juejin.im/post/5a77fda06fb9a0634c264bf2
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var txt = 'FUTU';
        ctx.textBaseline = 'middle';
        ctx.font = '14px "Arial"';
        ctx.fillStyle = '#2041dd';
        ctx.fillText(txt, 4, 17);

        var b64 = canvas.toDataURL().replace('data:image/png;base64,', '');
        var bin = atob(b64);
        crc = util.bin2hex(bin.slice(-16, -12));
    } catch (e) {
        crc = '';
    }
    return crc;
}
/**
 * 获取 AudioContext 指纹信息
 * @static
 * @public
 * @param {Function} callback 回掉函数
 * @return {void}
 * 
 * https://github.com/RobinLinus/ubercookie/blob/master/index.html
 */
function getAudioFP(callback) {
    // Details: https://audiofingerprint.openwpm.com/
    try {
        var hybrid_output = [];
        var audioCtx = new (window.AudioContext || window.webkitAudioContext)(),
            oscillator = audioCtx.createOscillator(),
            analyser = audioCtx.createAnalyser(),
            gain = audioCtx.createGain(),
            scriptProcessor = audioCtx.createScriptProcessor(4096, 1, 1),
            compressor;
        // Create and configure compressor
        compressor = audioCtx.createDynamicsCompressor();
        compressor.threshold && (compressor.threshold.value = -50);
        compressor.knee && (compressor.knee.value = 40);
        compressor.ratio && (compressor.ratio.value = 12);
        compressor.reduction && (compressor.reduction.value = -20);
        compressor.attack && (compressor.attack.value = 0);
        compressor.release && (compressor.release.value = .25);
        gain.gain.value = 0; // Disable volume
        oscillator.type = 'triangle'; // Set oscillator to output triangle wave
        oscillator.connect(compressor); // Connect oscillator output to dynamic compressor
        compressor.connect(analyser); // Connect compressor to analyser
        analyser.connect(scriptProcessor); // Connect analyser output to scriptProcessor input
        scriptProcessor.connect(gain); // Connect scriptProcessor output to gain input
        gain.connect(audioCtx.destination); // Connect gain output to audiocontext destination
        scriptProcessor.onaudioprocess = function (bins) {
            bins = new window.Float32Array(analyser.frequencyBinCount);
            analyser.getFloatFrequencyData(bins);
            for (var i = 0; i < bins.length; i = i + 1) {
                hybrid_output.push(bins[i]);
            }
            analyser.disconnect();
            scriptProcessor.disconnect();
            gain.disconnect();
            var audioFp = (0, _stringify2.default)(hybrid_output);
            callback(audioFp);
        };
        oscillator.start(0);
    } catch (err) {
        callback();
    }
}
/**
 * defer获取 Webrt 指纹信息
 * @static
 * @public
 * @return {Object} promise
 */
function getWebrtcDefer() {
    return new _promise2.default(function (resolve, reject) {
        getIPs(function (ip) {
            clearTimeout(STO);
            if (!ip) {
                //失败回调
                resolve('');
            } else {
                CACHE.fp_webrtc = CACHE.fp_webrtc || ip;
                resolve(CACHE.fp_webrtc);
            }
        });
    });
}

/**
 * 获取 WebGL采集的指纹信息
 * @static
 * @public
 * @return {Object} [获取WebGL采集的指纹信息]
 */
function getWebGLFingerPrint() {
    var crc = '';

    try {
        var canvas = document.createElement('canvas');
        var gl = canvas.getContext('experimental-webgl');
        var debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        crc = { UNMASKED_RENDERER_WEBGL: debugInfo.UNMASKED_RENDERER_WEBGL, UNMASKED_VENDOR_WEBGL: debugInfo.UNMASKED_VENDOR_WEBGL };
    } catch (e) {
        crc = '';
    }

    return crc;
}
/**
 * 获取 WebRTC采集的ip
 * @static
 * @public
 * @param {Function} callback 回掉函数
 * @return {Object} [获取 WebRTC采集的ip]
 * https://blog.csdn.net/Revivedsun/article/details/100096667
 */
function getIPs(callback) {
    var ip_dups = {};
    var handleCandidate = function handleCandidate(candidate) {
        //match just the IP address
        var ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/;
        if (ip_regex.exec(candidate)) {
            var ip_addr = ip_regex.exec(candidate)[1];
        }

        //remove duplicates
        if (ip_addr) {
            if (!ip_dups[ip_addr]) {
                return ip_addr;
            }

            ip_dups[ip_addr] = true;
        }
        return;
    };

    var RTCPeer = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;

    if (RTCPeer) {

        var ICE_config = {
            'iceServers': [{
                'urls': 'stun:stun.l.google.com:19302'
            }]
        };
        var pc = new RTCPeer(ICE_config);

        pc.createDataChannel('', { reliable: false });

        pc.createOffer(function (result) {
            pc.setLocalDescription(result, function () {}, function () {});
        }, function () {
            callback();
        });

        pc.onicecandidate = function (ice) {
            if (ice.candidate) {
                var ip = handleCandidate(ice.candidate.candidate);
                if (ip) {
                    callback(ip);
                }
            }
        };

        STO = setTimeout(function () {
            var fig = false;

            if (pc && pc.localDescription && pc.localDescription.sdp) {
                var lines = pc.localDescription.sdp.split('\n');
                var ip = '';
                lines.some(function (line) {
                    if (line.indexOf('a=candidate:') === 0) {
                        ip = handleCandidate(line);
                        if (ip) {
                            return;
                        }
                    }
                });

                callback(ip);
            } else {
                callback();
            }
        }, 100);
    } else {
        callback();
    }
}

/**
 * 获取老浏览器环境变量信息
 * @public
 * @static
 * @since 2.10.0
 * @return {Promise} [resolve 环境变量信息]
 */
function getEnv() {
    CACHE.fp_webgl = CACHE.fp_webgl || getWebGLFingerPrint();

    // 缓存一部分需要计算的环境变量
    CACHE.lang = CACHE.lang || browser.getClientLang('all');
    CACHE.java_enabled = CACHE.java_enabled || navigator.javaEnabled && navigator.javaEnabled();
    CACHE.time_zone = CACHE.time_zone || new Date().getTimezoneOffset() / 60;
    CACHE.is_track = 'is_track' in CACHE ? CACHE.is_track : +(navigator.msDoNotTrack || window.doNotTrack || navigator.doNotTrack) === 1;
    // 可能一些浏览器不支持canvas，给个默认值
    CACHE.canvas_id = CACHE.canvas_id || getCanvasFingerPrint() || '00000000';

    //新增字段 2019.11.04
    CACHE.cookie_enabled = CACHE.cookie_enabled || window.navigator.cookieEnabled;
    CACHE.is_support_indexdb = CACHE.is_support_indexdb || Boolean(window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB);
    CACHE.refer = CACHE.refer || document.referrer;
    CACHE.connection_type = CACHE.connection_type || navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    CACHE.page_link = CACHE.page_link || window.location.href;

    var fetchEnv = function fetchEnv() {
        return {
            os_type: uAgent.os.name,
            os_ver: uAgent.os.version,
            time_zone: CACHE.time_zone,
            // 浏览器可见区域
            screen_size: document.documentElement.clientWidth + 'x' + document.documentElement.clientHeight,
            user_agent: navigator.userAgent.toLocaleLowerCase(),
            plugins: getPlugins(),
            croll_top: Math.max(document.documentElement.scrollTop, document.body.scrollTop),
            lang: CACHE.lang,
            java_enabled: CACHE.java_enabled,
            canvas_id: getCanvasFingerPrint(),
            color_depth: screen.colorDepth,
            pixel_depth: screen.pixelDepth,
            touch_enabled: 'ontouchstart' in window,
            touch_count: CACHE.touch_count,
            key_count: CACHE.key_count,
            tap_count: CACHE.tap_count,
            mouse_click: CACHE.mouse_click,
            mouse_move: CACHE.mouse_move,
            bat_level: 0,
            bat_charging: false,
            bat_chargtime: 0,
            screen_height: window.screen.height,
            screen_width: window.screen.width,
            gyro_x: CACHE.gyro_x,
            gyro_y: CACHE.gyro_y,
            gyro_z: CACHE.gyro_z,
            cpu: navigator.hardwareConcurrency || 0,
            acce_x: CACHE.acce_x,
            acce_y: CACHE.acce_y,
            acce_z: CACHE.acce_z,
            is_track: CACHE.is_track,
            cookie_enabled: CACHE.cookie_enabled,
            is_support_indexdb: CACHE.is_support_indexdb,
            refer: CACHE.refer,
            connection_type: CACHE.connection_type !== '' && CACHE.connection_type !== undefined ? CACHE.connection_type.effectiveType : '',
            scroll_count: CACHE.scroll_count,
            fp_webgl: CACHE.fp_webgl,
            page_link: CACHE.page_link,
            click_time: Date.now() / 1000 >> 0 + '',
            fp_audio: CACHE.fp_audio
        };
    };

    return _promise2.default.all([navigator.getBattery ? navigator.getBattery() : {
        level: 1,
        charging: false,
        chargtime: 0
    }, new _promise2.default(function (resolve) {
        setTimeout(function () {
            resolve(fetchEnv());
        }, 200);
    })]).then(function (resArr) {
        var env = resArr[1];
        // 电池信息
        var batteryManager = resArr[0];
        // 电池电量，取值为0-1
        env.bat_level = batteryManager.level;
        // 是否充电
        env.bat_charging = batteryManager.charging;
        // 电池完全充电前的剩余时间（以秒为单位）,如果电池已充满电或是没有电池，则为0。
        env.bat_chargtime = batteryManager.chargtime || 0;
        env.bat_chargtime = env.bat_chargtime === Infinity ? 0 : env.bat_chargtime;
        return env;
    });
}